/**
 * @generated SignedSource<<bdb149c93a2155297b62352a931fcac3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type CustomColor = "A" | "B" | "C" | "D" | "E" | "F";
import { FragmentRefs } from "relay-runtime";
export type InlineRestrictionsList_timeSlot$data = {
  readonly bookingRules: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly displayName: string | null | undefined;
        readonly id: string;
        readonly name: string;
        readonly visibilityColor?: CustomColor | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "InlineRestrictionsList_timeSlot";
};
export type InlineRestrictionsList_timeSlot$key = {
  readonly " $data"?: InlineRestrictionsList_timeSlot$data;
  readonly " $fragmentSpreads": FragmentRefs<"InlineRestrictionsList_timeSlot">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InlineRestrictionsList_timeSlot",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "bookingType",
          "value": [
            "STANDARD"
          ]
        },
        {
          "kind": "Literal",
          "name": "memberOverride",
          "value": [
            "NONE",
            "WARN"
          ]
        },
        {
          "kind": "Literal",
          "name": "memberVisibility",
          "value": "SLOTS_AND_RESTRICTION_INLINE"
        },
        {
          "kind": "Literal",
          "name": "type",
          "value": [
            "RESTRICTION"
          ]
        }
      ],
      "concreteType": "SlotBookingRulesConnection",
      "kind": "LinkedField",
      "name": "bookingRules",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SlotBookingRulesEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "displayName",
                  "storageKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "visibilityColor",
                      "storageKey": null
                    }
                  ],
                  "type": "BookingRestrictionRule",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "bookingRules(bookingType:[\"STANDARD\"],memberOverride:[\"NONE\",\"WARN\"],memberVisibility:\"SLOTS_AND_RESTRICTION_INLINE\",type:[\"RESTRICTION\"])"
    }
  ],
  "type": "TimeSlot",
  "abstractKey": null
};

(node as any).hash = "a950ac0bdb24687fd745fd9cb699f5f8";

export default node;
